import { UseQueryOptions, useQuery } from "@tanstack/react-query";

import { ReportSearchResult } from "types";
import { ReportsAPI } from "api";
import { cacheKeyForDateRange } from "utils";

export type ReportsListArgs = Parameters<typeof ReportsAPI.list>[0];

const queryKeys = {
  all: () => ["reports"] as const,
  search: ({ updatedAfter = null, updatedBefore = null, ...args }: ReportsListArgs) =>
    [
      ...queryKeys.all(),
      "search",
      {
        ...args,
        ...cacheKeyForDateRange({ startDate: updatedAfter, endDate: updatedBefore }),
      },
    ] as const,
};

/**
 * Searches reports based on the provided input params.
 */
export const useSearchReports = <T = ReportSearchResult>(
  args: ReportsListArgs,
  options: UseQueryOptions<ReportSearchResult, unknown, T> = {},
) => useQuery<ReportSearchResult, unknown, T>(queryKeys.search(args), () => ReportsAPI.list(args), options);
